import { defineMessages } from "react-intl";

export const pluginsFilterErrorMessages = defineMessages({
  active: {
    id: "T/dYnE",
    defaultMessage: "Status is not selected",
    description: "plugin filters error messages status",
  },
  channels: {
    id: "gZHmaV",
    defaultMessage: "No channels selected",
    description: "plugin filters error messages channels",
  },
});
